import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReportContentWrapper = styled.div`
  border-radius: ${BorderRadius.R12};
  outline: 1px solid ${Color.Grey200};
  background-color: ${Color.White};
  overflow: hidden;
  ${getShadow('raisedLight')};
`

export const PreviewSkeletonWrapper = styled.div`
  padding: ${Spacing.S16};
`
